import { preloadSpaceViews } from '@confluence/space-views/entry-points/preloadSpaceViews.ts';
import { preloadShortcutsSmartLinks } from '@confluence/space-shortcuts/entry-points/preloadShortcutsSmartLinks.ts';
import { preloadSideNavigation } from '@confluence/side-navigation/entry-points/preloadSideNavigation.ts';
import { preloadSpaceGuestList } from '@confluence/space-guest-list/entry-points/preloadSpaceGuestList.ts';
import { preloadContentTypesHeader } from '@confluence/content-types-header/entry-points/preloadContentTypesHeader.js';
import { preloadPageRestrictionsQuery } from '@confluence/page-restrictions-context/entry-points/preloadPageRestrictionsQuery.ts';
import { preloadWhiteboardData } from '@confluence/whiteboard-common/entry-points/preloadWhiteboardData.ts';
import { preloadShareAndRestrictButtonQuery } from '@confluence/share-and-restrict-dialog/entry-points/preloadShareAndRestrictButtonQuery.ts';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { fg } from '@confluence/feature-gating';
import { preloadSmartCreateFeedbackBanner } from '@confluence/editor-action-bar/entry-points/preloadSmartCreateFeedbackBanner.ts';

export const preloadWhiteboardRoute = async (
	match: RouteMatch,
	_url: string,
	isTransition: boolean = false,
) => {
	const { isLicensed } = getPreloaderFnContext();
	const tasks: Promise<any>[] = [];
	const { spaceKey, contentId } = match.params;

	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR) {
		// Only load data for navigation in React SSR since we are delaying them in the SPA
		tasks.push(
			preloadSideNavigation(spaceKey),
			preloadSpaceGuestList(spaceKey),
			preloadShortcutsSmartLinks(spaceKey),
		);
	} else if (!isTransition) {
		tasks.push(preloadSpaceViews(spaceKey, isLicensed));
	}

	// Content types header (object header)
	if (fg('confluence_frontend_content_wrapper')) {
		tasks.push(preloadContentTypesHeader(contentId, fg('confluence_frontend_content_wrapper')));
		// Standalone Restrictions button needs to have its data preloaded)
		tasks.push(preloadPageRestrictionsQuery(contentId, false));
	}

	// Unified Share and Restrict Button
	if (fg('confluence_frontend_usd_ssr')) {
		tasks.push(preloadShareAndRestrictButtonQuery(contentId));
	}

	if (fg('aifc_create_enabled')) {
		tasks.push(preloadSmartCreateFeedbackBanner(contentId));
	}

	tasks.push(
		preloadWhiteboardData({
			spaceKey,
			contentId,
		}),
	);

	return waitForAllReturnWhenError(tasks);
};
